import dynamic from 'next/dynamic';

import { logger } from '#utils/logging/logger.ts';

export const ArdPlayer = dynamic(() => import('./ArdPlayerInternal').then(({ ArdPlayer }) => ArdPlayer), {
	ssr: false,
	loading(loadingProps) {
		if (loadingProps.error) {
			logger.error(loadingProps.error);
		}

		return null;
	},
});
